import { useLazyQuery } from '@apollo/client';
import { QueryResult, Variables } from './types';
import { bankDetailsQuery } from './gql';

export const useBankDetailsGql = () => {
  const [runBankDetailsGql, { loading, data, error }] = useLazyQuery<QueryResult, Variables>(bankDetailsQuery, {
    context: {
      headers: {
        userFunctionKey: '9f61408e3afb633e50cdf1b20de6f466'
      }
    },
    fetchPolicy: 'network-only'
  });

  return {
    runBankDetailsGql,
    loadingBankDetails: loading,
    dataBankDetails: data?.getBankDetails || [],
    errorBankDetails: error
  };
};
